import {Field, FormActions, Section} from 'components/form/ModernForm'
import {Formik} from 'formik'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo} from 'react'
import {SelectWidget} from 'views/AppLocals/custom/ReactSelectComponents'
import {NullAsDefault} from 'views/Shared'
import {medal_getMedals_Api} from "../../../../apis";
import useAsync from "../../../../modules/asyncCache/useAsync";
import {bindQueryParams} from "../../functions/routerHelper";
import filterOption from "../../../../helpers/filterOption";
import {GoDotFill} from "react-icons/go";

// Select 1 chứng nhận (medal) - tái dùng cho cả 3 field, options lấy từ danh sách medals của owner.
const MedalSelect = ({value, medals = [], disabled = false, onChange}) => {
    const t = useTranslate()
    return (
        <SelectWidget
            value={value}
            className="w-full"
            placeholder={t('click to select')}
            showSearch={true}
            disabled={disabled}
            options={medals.map((e) => ({label: e.title, value: e.id}))}
            filterOption={filterOption}
            onChange={(v) => onChange(v)}
        />
    )
}

export const CourseMergeMedal = ({
                                     course,
                                     onCancel = NullAsDefault,
                                     owner_id,
                                     owner_type,
                                     isSubmitting,
                                     onSubmit = NullAsDefault,
                                 }) => {
    const t = useTranslate()

    const {response} = useAsync({
        apiInfo: medal_getMedals_Api,
        query: bindQueryParams([{prop: owner_type}, {id: owner_id}]),
    })

    const medals = _.get(response, 'data.data', []);

    const validate = (values) => {
        const {medal_1_id, medal_2_id, new_medal_id} = values ?? {}
        let errors = {}

        if (_.isEmpty(medal_1_id)) {
            errors.medal_1_id = t('required field')
        }
        if (_.isEmpty(medal_2_id)) {
            errors.medal_2_id = t('required field')
        }
        if (_.isEmpty(new_medal_id)) {
            errors.new_medal_id = t('required field')
        }
        return errors
    }

    const initialValues = useMemo(() => {
        return {
            owner_id,
            owner_type,
            medal_1_id: undefined,
            medal_2_id: course?.medal?.id,
            new_medal_id: undefined,
            medals
        }
    }, [medals, owner_id, owner_type])

    return !!medals.length && (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                onSubmit(values)
            }}>
            {({values, touched, errors, isValid, setFieldValue, handleSubmit}) => (
                <form onSubmit={handleSubmit} className="flex flex-col gap-3">
                    <div className="p-2 border-2 border-orange-300 rounded-lg flex flex-col gap-2 italic">
                        <div className="flex flex-col">
                            <span className="font-bold text-xs text-orange-500">
                                {`${t('notes')} : `}
                            </span>
                            <span className="ml-3 text-xs text-color-300">
                                {t('Students who have obtained Certificate 1 (from a different course) and Certificate 2 (from this course) will be awarded an additional certificate, selected from the options below.')}
                            </span>
                        </div>
                        <div className="flex flex-col">
                            <span className="font-bold text-xs text-color-100">
                                {t('example')}
                            </span>
                            <span className="ml-3 text-xs text-color-300">
                                <GoDotFill size={10} className="text-color-400 mr-1"/>
                                {t('example merge medal description 1')}
                            </span>
                            <span className="ml-3 text-xs text-color-300">
                                <GoDotFill size={10} className="text-color-400 mr-1"/>
                                {t('example merge medal description 2')}
                            </span>
                        </div>
                    </div>

                    <Section>
                        <Field
                            label={t('medal 1')}
                            required
                            error={touched.medal_1_id && errors.medal_1_id}>
                            <MedalSelect
                                value={values.medal_1_id}
                                medals={values.medals}
                                onChange={(v) => setFieldValue('medal_1_id', v)}
                            />
                            <span className="mt-1 text-2xs text-color-400 italic leading-snug">
                                {t('merge medal field 1 hint')}
                            </span>
                        </Field>
                        <Field
                            label={t('medal 2')}
                            required
                            error={touched.medal_2_id && errors.medal_2_id}>
                            <MedalSelect
                                value={values.medal_2_id}
                                medals={values.medals}
                                disabled
                                onChange={(v) => setFieldValue('medal_2_id', v)}
                            />
                            <span className="mt-1 text-2xs text-color-400 italic leading-snug">
                                {t('merge medal field 2 hint')}
                            </span>
                        </Field>
                        <Field
                            label={t('new medal')}
                            required
                            error={touched.new_medal_id && errors.new_medal_id}>
                            <MedalSelect
                                value={values.new_medal_id}
                                medals={values.medals}
                                onChange={(v) => setFieldValue('new_medal_id', v)}
                            />
                            <span className="mt-1 text-2xs text-color-400 italic leading-snug">
                                {t('merge medal new hint')}
                            </span>
                        </Field>
                    </Section>

                    <FormActions
                        onCancel={onCancel}
                        submitText="merge"
                        isSubmitting={isSubmitting}
                        isValid={isValid}
                    />
                </form>
            )}
        </Formik>
    )
}
